import Vue from "vue";
import Router from "vue-router";
import config from "../config";
import { menuItems } from "../components/menu.js";
import { error_message } from "../Helper/helper.js";

Vue.use(Router);

const urls = menuItems.reduce(
    (m, i) => (i.subItems ? m.concat(i.subItems) : m.concat(i)),
    []
);

const base = config.base_folder;

const vendorRoutes = [
    {
        path: base + "login",
        name: "login",
        component: () => import("../views/account/login.vue"),
    },
    {
        path: base + "admin/login",
        name: "admin-login",
        component: () => import("../views/account/admin/login.vue"),
    },
    {
        path: base + "signup",
        name: "signup",
        component: () => import("../views/account/signup.vue"),
    },
    {
        path: base + "quick-signup",
        name: "quick-signup",
        component: () => import("../views/account/quick-signup.vue"),
    },
    {
        path: base + "account-setup",
        name: "account-setup",
        component: () => import("../views/account/progress.vue"),
    },
    {
        path: base + "reseller",
        name: "reseller",
        component: () => import("../views/reseller/list.vue"),
        access: true,
    },
    {
        path: base + "dashboard",
        name: "dashboard",
        component: () => import("../views/dashboard.vue"),
    },
    {
        path: base + "orders/list",
        name: "orders-list",
        component: () => import("../views/orders/main.vue"),
    },
    {
        path: base + "subscriptions/list",
        name: "subscriptions-list",
        component: () => import("../views/subscriptions/main.vue"),
    },
    {
        path: base + "subscriptions/details/:id",
        name: "subscriptions.details",
        component: () => import("../views/subscriptions/details.vue"),
    },
    {
        path: base + "customer",
        name: "customer-list",
        //component: () => import("../views/customer/list.vue"),
        component: () => import("../views/customer/base-customer-view.vue"),
        access: true,
    },
    {
        path: base + "customer/segmentation/all-customer",
        name: "customer.segmentation.all-customer",
        component: () => import("../views/customer/all-customer/list.vue"),
    },
    {
        path: base + "customer/segmentation/day-wise-customer",
        name: "customer.segmentation.day-wise-customer",
        component: () => import("../views/customer/day-wise-customer/list.vue"),
    },
    {
        path: base + "customer/segmentation/no-order-customer",
        name: "customer.segmentation.no-order-customer",
        component: () =>
            import("../views/customer/no-order-days-customer/list.vue"),
    },
    {
        path: base + "customer/segmentation/with-wallet-balance-customer",
        name: "customer.segmentation.with-wallet-balance-customer",
        component: () =>
            import("../views/customer/with-wallet-balance-customer/list.vue"),
    },
    {
        path: base + "customer/segmentation/with-cancel-order-customer",
        name: "customer.segmentation.with-cancel-order-customer",
        component: () =>
            import("../views/customer/with-cancel-order-customer/list.vue"),
    },
    {
        path: base + "customer/segmentation/with-maximum-order-customer",
        name: "customer.segmentation.with-maximum-order-customer",
        component: () =>
            import("../views/customer/with-maximum-order-customer/list.vue"),
    },
    {
        path: base + "customer/segmentation/with-os-wise-customer",
        name: "customer.segmentation.with-os-wise-customer",
        component: () =>
            import("../views/customer/operating-system-wise-customer/list.vue"),
    },
    {
        path: base + "customer/segmentation/with-average-order-customer",
        name: "customer.segmentation.with-average-order-customer",
        component: () =>
            import("../views/customer/with-average-order-customer/list.vue"),
    },
    {
        path: base + "customer/segmentation/with-promo-code-usage-customer",
        name: "customer.segmentation.with-promo-code-usage-customer",
        component: () =>
            import("../views/customer/with-promo-code-usage-customer/list.vue"),
    },
    {
        path: base + "customer/segmentation/posted-restaurant-negative-reviews",
        name: "customer.segmentation.posted-restaurant-negative-reviews",
        component: () =>
            import(
                "../views/customer/posted-restaurant-negative-reviews/list.vue"
            ),
    },
    {
        path: base + "customer/segmentation/posted-driver-negative-reviews",
        name: "customer.segmentation.posted-driver-negative-reviews",
        component: () =>
            import("../views/customer/posted-driver-negative-reviews/list.vue"),
    },
    {
        path: base + "customer/segmentation/pro-customers",
        name: "customer.segmentation.pro-customers",
        component: () => import("../views/customer/pro-customers/list.vue"),
    },
    {
        path: base + "customer/details/:user_id",
        name: "customer-detail",
        component: () => import("../views/customer/details.vue"),
        access:true,
    },
    {
        path: base + "drivers/:vendor_id/signup",
        name: "driver-signup",
        component: () => import("../views/driver/signup.vue"),
    },
    {
        path: base + "driver/dashboard",
        name: "driver-dashboard",
        component: () => import("../views/driver/dashboard.vue"),
    },
    {
        path: base + "drivers",
        name: "driver-list",
        component: () => import("../views/driver/list.vue"),
    },
    {
        path: base + "drivers/add",
        name: "driver-add",
        component: () => import("../views/driver/add.vue"),
    },
    {
        path: base + "drivers/details/:driver_id",
        name: "driver-details",
        component: () => import("../views/driver/details.vue"),
    },
    {
        path: base + "location",
        name: "country-list",
        component: () => import("../views/location/list.vue"),
    },
    {
        path: base + "location/state-list/:country_id",
        name: "state-list",
        component: () => import("../views/location/state-list.vue"),
    },
    {
        path: base + "location/city-list/:state_id",
        name: "city-list",
        component: () => import("../views/location/city-list.vue"),
    },
    {
        path: base + "delivery_zone",
        name: "list",
        component: () => import("../views/delivery_zone/list.vue"),
    },
    {
        path: base + "delivery_zone/add",
        name: "delivery-zone-add",
        component: () => import("../views/delivery_zone/add.vue"),
    },
    {
        path: base + "delivery_zone/edit/:user_id",
        name: "delivery-zone-edit",
        component: () => import("../views/delivery_zone/edit.vue"),
    },
    {
        path: base + "delivery_zone/details/:user_id",
        name: "delivery-zone-details",
        component: () => import("../views/delivery_zone/details.vue"),
    },
    {
        path: base + "delivery_zone/add-area/:frenchiese_id",
        name: "add-area",
        component: () => import("../views/delivery_zone/add-area.vue"),
    },
    {
        path: base + "delivery_zone/edit-area/:area_id",
        name: "edit-area",
        component: () => import("../views/delivery_zone/edit-area.vue"),
    },
    {
        path: base + "coupon",
        name: "coupon-list",
        component: () => import("../views/coupon/list.vue"),
    },
    {
        path: base + "coupon/add",
        name: "coupon-add",
        component: () => import("../views/coupon/add.vue"),
    },
    {
        path: base + "coupon/edit/:id",
        name: "coupon-edit",
        component: () => import("../views/coupon/edit.vue"),
    },
    {
        path: base + "finance/driver",
        name: "driver",
        component: () => import("../views/finance/driver.vue"),
    },
    {
        path: base + "finance/driver/month/:month",
        name: "driver-finance-month",
        component: () =>
            import("../views/finance/driver/driver-finance-month.vue"),
    },
    {
        path: base + "finance/driver/:driverid/transactions",
        name: "driver-finance-transactions",
        component: () =>
            import("../views/finance/driver/driver-transaction.vue"),
    },
    {
        path: base + "finance/vendor",
        name: "vendor",
        component: () => import("../views/finance/vendor.vue"),
    },
    {
        path: base + "finance/vendor/month/:month",
        name: "vendor-finance-month",
        component: () => import("../views/finance/vendor-finance-month.vue"),
    },
    {
        path: base + "finance/vendor-finance-list",
        name: "vendor-finance-list",
        component: () => import("../views/finance/vendor-finance-list.vue"),
    },
    {
        path: base + "finance/vendor/month/:month/:id/dashboard",
        name: "restaurant-finance-list",
        component: () =>
            import("../views/finance/restaurant/restaurant-finance.vue"),
    },
    {
        path: base + "finance/vendor/:id/transactions",
        name: "restaurant-transaction-list",
        component: () =>
            import("../views/finance/restaurant/restaurant-transaction.vue"),
    },
    // {
    //     path: base + "faq",
    //     name: "faq-list",
    //     component: () => import("../views/faq/list.vue"),
    // },
    // {
    //     path: base + "faq/add",
    //     name: "faq-add",
    //     component: () => import("../views/faq/add.vue"),
    // },
    // {
    //     path: base + "faq/edit/:id",
    //     name: "faq-edit",
    //     component: () => import("../views/faq/edit.vue"),
    // },
    // order configurations
    {
        path: base + "settings/delivery-zone-configurations",
        name: "delivery-zone-configurations",
        component: () =>
            import("../views/settings/delivery-zone-configurations.vue"),
    },
    // Driver configurations
    {
        path: base + "settings/driver-configurations",
        name: "driver-configurations",
        component: () => import("../views/settings/driver-configurations.vue"),
    },
    // General Configurations in Dz
    {
        path: base + "settings/general-configurations",
        name: "general-configurations",
        component: () => import("../views/settings/general-configurations.vue"),
    },
    {
        path: base + "reports",
        name: "reports-list",
        component: () => import("../views/reports/list.vue"),
    },
    {
        path: base + "reports/sales_report",
        name: "reports.sale.report",
        component: () => import("../views/reports/sales_report.vue"),
    },
    {
        path: base + "reports/customer_report",
        name: "reports.customer.report",
        component: () => import("../views/reports/customer_report.vue"),
    },
    {
        path: base + "reports/total_sales_earning",
        name: "reports.total.earning",
        component: () => import("../views/reports/total_sales_earning.vue"),
    },
    {
        path: base + "reports/tax_report",
        name: "reports.tax.report",
        component: () => import("../views/reports/tax_report.vue"),
    },
    {
        path: base + "reports/driver_report",
        name: "reports.driver.report",
        component: () => import("../views/reports/driver_report.vue"),
    },
    {
        path: base + "reports/inactive_customer_report",
        name: "reports.inactive.customer.report",
        component: () =>
            import("../views/reports/inactive_customer_report.vue"),
    },
    {
        path: base + "reports/cod_online_order_report",
        name: "reports.cod.online.order.report",
        component: () => import("../views/reports/cod_online_order_report.vue"),
    },
    {
        path: base + "reports/avg_rating_report",
        name: "reports.avg.rating.report",
        component: () => import("../views/reports/avg_rating_report.vue"),
    },
    {
        path: base + "reports/promo_code_report",
        name: "reports.promo.code.report",
        component: () => import("../views/reports/promo_code_report.vue"),
    },
    {
        path: base + "reports/driver_report_details",
        name: "driver.reports.details",
        component: () => import("../views/reports/driver_report_details.vue"),
    },
    {
        path: base + "reports/wallet_report",
        name: "report.wallet",
        component: () => import("../views/reports/wallet_report.vue"),
    },
    {
        path: base + "settings/terminology",
        name: "terminology-list",
        component: () => import("../views/settings/terminology.vue"),
    },
    {
        path: base + "profile/subscription_info",
        name: "subscription-info",
        component: () => import("../views/profile/subscription_info.vue"),
        access: true,
    },
    {
        path: base + "profile/change-password",
        name: "change-password",
        component: () => import("../views/profile/change-password.vue"),
        access: true,
    },
    {
        path: base + "profile/business-profile",
        name: "business-profile",
        component: () => import("../views/profile/business-profile.vue"),
        access: true,
    },
    {
        path: base + "help/list",
        name: "help",
        component: () => import("../views/help/list.vue"),
        access: true,
    },
    {
        path: base + "whatsnew",
        name: "whats-new",
        component: () => import("../views/whatsnew/whats-new.vue"),
        access: true,
    },
    {
        path: base + "client/list",
        name: "client-list",
        component: () => import("../views/client/list.vue"),
        access: true,
    },
    {
        path: base + "currency",
        name: "currency-list",
        component: () => import("../views/currency/list.vue"),
        access: true,
    },
    {
        path: base + "client-reports",
        name: "client-report",
        component: () => import("../views/client_report/report.vue"),
        access: true,
    },
    {
        path: base + "maintenance/system",
        name: "maintenance-system",
        component: () => import("../views/maintenance/system.vue"),
        access: true,
    },
    {
        path: base + "changelog",
        name: "change-log",
        component: () => import("../views/change-log.vue"),
        access: true,
    },
    {
        path: base + "reports/vendor_rating_review_report",
        name: "reports.vendor.rating.review.report",
        component: () =>
            import("../views/reports/vendor_rating_review_report.vue"),
    },
    {
        path: base + "reports/driver_rating_review_report",
        name: "reports.driver.rating.review.report",
        component: () =>
            import("../views/reports/driver_rating_review_report.vue"),
    },
    {
        path: base + "reports/order-status-report",
        name: "reports.order-status.report",
        component: () =>
            import("../views/reports/order-status/order-status-report.vue"),
    },
    
    {
        path: base + "reports/subscription-report",
        name: "reports.subscription.report",
        component: () =>
            import("../views/reports/subscription_report.vue"),
    },
    {
        path: base + "reports/subscription-order-report",
        name: "reports.subscription.order.report",
        component: () =>
            import("../views/reports/subscription_order_report.vue"),
    },
    {
        path: base + "reports/fuel_sell_report",
        name: "reports.fuel.sell",
        component: () =>
            import("../views/reports/fuel_sell_report.vue"),
    },

    {
        path: base + "reports/driver_settlement_report",
        name: "reports.driver.settlement",
        component: () =>
            import("../views/reports/driver_settlement_report.vue"),
    },
    {
        path: base + "analytics",
        name: "analytics",
        component: () => import("../views/analytics/analytics.vue"),
        access: true,
    },
    {
        path: base + "business-type",
        name: "business-type-list",
        component: () => import("../views/business_type/list.vue"),
        access: true,
    },
    {
        path: base + "business-type/edit/:id",
        name: "business-type-edit",
        component: () => import("../views/business_type/edit.vue"),
        access: true,
    },
    {
        path: base + "wallet-dashboard",
        name: "wallet-dashboard",
        //component: () => import("../views/finance/wallet/wallet-dashboard.vue"),
        component: () => import("../views/finance/wallet/base-view.vue"),
        // access: true,
    },
    {
        path: base + "wallet-dashboard/month/:month",
        name: "wallet-dashboard-finance-month",
        component: () => import("../views/finance/wallet/finance-month.vue"),
    },
    {
        path: base + "finance/driver/month/:month/:driverid/dashboard",
        name: "driver-finance",
        component: () =>
            import("../views/finance/driver/driver-finance-detail.vue"),
    },
    {
        path: base + "category",
        name: "category-list",
        component: () => import("../views/category/list.vue"),
    },
    {
        path: base + "category/add",
        name: "category-add",
        component: () => import("../views/category/add.vue"),
    },
    {
        path: base + "category/edit/:category_id",
        name: "category-edit",
        component: () => import("../views/category/edit.vue"),
    },
    {
        path: base + "system/list",
        name: "system-list",
        component: () => import("../views/system/list.vue"),
    },
    {
        path: base + "settings/operation-time",
        name: "operation-time",
        component: () => import("../views/settings/operation-time.vue"),
    },
    {
        path: base + "settings/holiday-management",
        name: "holiday-management",
        component: () => import("../views/settings/holiday-management.vue"),
    },
    {
        path: base + "cuisines",
        name: "cuisines-list",
        component: () => import("../views/cuisines/list.vue"),
    },
    {
        path: base + "cuisines/add",
        name: "cuisines-add",
        component: () => import("../views/cuisines/add.vue"),
    },
    {
        path: base + "cuisines/edit/:cuisine_id",
        name: "cuisines-edit",
        component: () => import("../views/cuisines/edit.vue"),
    },
    {
        path: base + "settings/configurations",
        name: "configurations",
        component: () => import("../views/settings/configurations.vue"),
    },
    {
        path: base + "settings/integrations",
        name: "integrations",
        component: () => import("../views/settings/integration.vue"),
        access: true,
    },
    {
        path: base + "settings/app-layout-setting",
        name: "app-layout-setting",
        component: () => import("../views/settings/app-layout-setting.vue"),
    },
    {
        path: base + "settings/web-layout-setting",
        name: "web-layout-setting",
        component: () => import("../views/settings/web-layout-setting.vue"),
        access: true,
    },
    {
        path: base + "settings/themes",
        name: "themes",
        component: () => import("../views/settings/themes.vue"),
    },
    {
        path: base + "content-page",
        name: "content-list",
        component: () => import("../views/content-page/list.vue"),
    },
    {
        path: base + "settings/user-access",
        name: "user-access",
        component: () => import("../views/settings/user-access/user-list.vue"),
        access: true,
    },
    {
        path: base + "settings/user-access/add",
        name: "user-access-add",
        component: () => import("../views/settings/user-access/add-user.vue"),
    },
    {
        path: base + "settings/user-access/:id/edit",
        name: "user-access-edit",
        component: () => import("../views/settings/user-access/edit-user.vue"),
    },
    {
        path: base + "settings/user-access/:id/permissions",
        name: "user-access.permissions",
        component: () =>
            import("../views/settings/user-access/user-permission.vue"),
    },
    {
        path: base + "content-page/add",
        name: "content-page-add",
        component: () => import("../views/content-page/add.vue"),
    },
    {
        path: base + "content-page/edit/:id",
        name: "content-page-edit",
        component: () => import("../views/content-page/edit.vue"),
    },
    {
        path: base + "content-page/view/:id",
        name: "content-page-view",
        component: () => import("../views/content-page/view-page.vue"),
    },
    {
        path: base + "client",
        name: "client-dashboard",
        component: () => import("../views/client/dashboard.vue"),
        access: true,
    },
    {
        path: base + "client/add",
        name: "client-add",
        component: () => import("../views/client/add.vue"),
        access: true,
    },
    {
        path: base + "reseller/add",
        name: "reseller-add",
        component: () => import("../views/reseller/business-profile.vue"),
        access: true,
    },
    {
        path: base + "reseller/edit/:vendor_id",
        name: "reseller-edit",
        component: () => import("../views/reseller/edit-business-profile.vue"),
        access: true,
    },
    {
        path: base + "client/edit/:vendor_id",
        name: "client-edit",
        component: () => import("../views/client/edit.vue"),
        access: true,
    },
    {
        path: base + "reports/feedback_report",
        name: "reports.feedback.report",
        component: () => import("../views/reports/feedback_report.vue"),
    },
    {
        path: base + "mails",
        name: "mail-list",
        component: () => import("../views/mail/list.vue"),
    },
    {
        path: base + "mails/add",
        name: "add-mail",
        component: () => import("../views/mail/add.vue"),
    },
    {
        path: base + "mails/edit/:id",
        name: "edit-mail",
        component: () => import("../views/mail/edit.vue"),
    },
    {
        path: base + "mails/view-page/:id",
        name: "view-mail",
        component: () => import("../views/mail/view-page.vue"),
    },
    // sales channel
    // {
    //   path: base+'sales-channels/whatsapp',
    //   name:"sales-channels-whatsapp",
    //   component: Whatsapp,
    //   access:true,
    // },
    // {
    //   path: base+'sales-channels/google-my-business',
    //   name:"sales-channels-google-my-business",
    //   component: GoogleMyBusiness,
    //   access:true,
    // },
    // {
    //   path: base+'sales-channels/facebook',
    //   name:"sales-channels-facebook",
    //   component: Facebook,
    //   access:true,
    // },
    // {
    //   path: base+'sales-channels/orderwidget',
    //   name:"sales-channels-orderwidget",
    //   component: OrderWidget,
    //   access:true,
    // },
    // {
    //   path: base+'sales-channels/apps',
    //   name:"sales-channels-apps",
    //   component: MobileApp,
    //   access:true,
    // },
    // {
    //   path: base+'sales-channels/qrcode',
    //   name:"sales-channels-qrcode",
    //   component: Qr,
    //   access:true,
    // },
    // {
    //   path: base+'sales-channels/orderwebsite',
    //   name:"sales-channels-orderwebsite",
    //   component: OrderWebsite,
    //   access:true,
    // },
    // {
    //   path: base+'sales-channels/customer-app',
    //   name:"sales-channels-customer-app",
    //   component: CustomerApp,
    //   access:true,
    // },
    // {
    //   path: base+'sales-channels/vendor-app',
    //   name:"sales-channels-vendor-app",
    //   component: VendorApp,
    //   access:true,
    // },
    // {
    //   path: base+'sales-channels/driver-app',
    //   name:"sales-channels-driver-app",
    //   component: DriverApp,
    //   access:true,
    // },
    // {
    //     path: base + "sales-channels",
    //     name: "sales-channels",
    //     component: () => import("../views/sales_channel/list.vue"),
    //     access: true,
    // },
    // {
    //     path: base + "sales-channels/whatsapp",
    //     name: "sales-channels-whatsapp",
    //     component: () => import("../views/sales_channel/Whatsapp.vue"),
    //     access: true,
    // },
    // {
    //     path: base + "sales-channels/google-my-business",
    //     name: "sales-channels-google-my-business",
    //     component: () =>
    //         import("../views/sales_channel/Google-my-business.vue"),
    //     access: true,
    // },
    // {
    //     path: base + "sales-channels/facebook",
    //     name: "sales-channels-facebook",
    //     component: () => import("../views/sales_channel/Facebook.vue"),
    //     access: true,
    // },
    // {
    //     path: base + "sales-channels/orderwidget",
    //     name: "sales-channels-orderwidget",
    //     component: () => import("../views/sales_channel/OrderWidget.vue"),
    //     access: true,
    // },
    // {
    //     path: base + "sales-channels/apps",
    //     name: "sales-channels-apps",
    //     component: () => import("../views/sales_channel/App.vue"),
    //     access: true,
    // },
    // {
    //     path: base + "sales-channels/qrcode",
    //     name: "sales-channels-qrcode",
    //     component: () => import("../views/sales_channel/Qr.vue"),
    //     access: true,
    // },
    // {
    //   path: base+'sales-channels/orderwebsite',
    //   name:"sales-channels-orderwebsite",
    //   component: () => import('../views/sales_channel/OrderWebsite.vue'),
    //   access:true,
    // },
    // {
    //   path: base+'sales-channels/customer-app',
    //   name:"sales-channels-customer-app",
    //   component: () => import('../views/sales_channel/Customer-app.vue'),
    //   access:true,
    // },
    // {
    //   path: base+'sales-channels/vendor-app',
    //   name:"sales-channels-vendor-app",
    //   component: () => import('../views/sales_channel/Vendor-app.vue'),
    //   access:true,
    // },
    // {
    //   path: base+'sales-channels/driver-app',
    //   name:"sales-channels-driver-app",
    //   component: () => import('../views/sales_channel/Driver-app.vue'),
    //   access:true,
    // },
    // sales channel

    // brand
    // {
    //     path: base + "brand",
    //     name: "brand",
    //     component: () => import("../views/brand/brand.vue"),
    //     access: true,
    // },
    // {
    //     path: base + "brand/add",
    //     name: "add-brand",
    //     component: () => import("../views/brand/brand-add.vue"),
    //     access: true,
    // },
    // {
    //     path: base + "brand/edit/:vendor_id",
    //     name: "edit-brand",
    //     component: () => import("../views/brand/brand-edit.vue"),
    //     access: true,
    // },
    {
        path: base + "review/list",
        name: "review-list",
        component: () => import("../views/review/list.vue"),
    },
    // {
    //   path : base+'review/driver',
    //   name : 'driver-review',
    //   component: () => import('../views/review/driver_review.vue')
    // },
    {
        path: base + "permission",
        name: "permission-page",
        component: () => import("../views/permission-page.vue"),
    },
    {
        path: base + "billing",
        name: "billing",
        component: () => import("../components/mybilling.vue"),
        access: true,
    },

    // Saas Client
    {
        path: base + "saas-client",
        name: "saas-client",
        component: () => import("../views/saas_client/list"),
        access: true,
    },    
    {
        path: base + "send_notification/send-notification",
        name: "send-notification",
        component: () => import("../views/send_notification/notification.vue"),
    },
    {
        path: base + "send_notification",
        name: "notification-history",
        component: () => import("../views/send_notification/history.vue"),
    },
    {
        path: base + "quickhelp",
        name: "quick-help",
        component: () => import("../views/help/quickhelp.vue"),
        access: true,
    },
    {
        path: base + "fuel-type",
        name: "fuel-type",
        component: () => import("../views/fuel_type/list.vue"),
        access: true,
    },
    {
        path: base + "vehicle-brand",
        name: "vehicle-brand",
        component: () => import("../views/vehicle_brand/list.vue"),
        access: true,
    },
    {
        path: base + "vehicle-model/:id",
        name: "vehicle-model",
        component: () => import("../views/vehicle_model/list.vue"),
        access: true,
    },
    {
        path: base + "add-model/:id",
        name: "add-model",
        component: () => import("../views/vehicle_model/add-model.vue"),
        access: true,
    },
    {
        path: base + "edit-model/:id",
        name: "edit-model",
        component: () => import("../views/vehicle_model/edit-model.vue"),
        access: true,
    },
    {
        path: base + "default-colour",
        name: "default-colour",
        component: () => import("../views/default_colour/list.vue"),
        access: true
    },
    {
        path: base + "add-colour",
        name: "add-colour",
        component: () => import("../views/default_colour/add-colour.vue"),
        access: true
    },
    {
        path: base + "edit-colour/:id",
        name: "edit-colour",
        component: () => import("../views/default_colour/edit-colour.vue"),
        access: true
    },
    {
        path: base + "stripe-subscription",
        name: "stripe-subscription",
        component: () => import("../views/stripe_subsciptions/list.vue"),
        access: true
    },
    {
        path: base + "stripe-price/:id",
        name: "stripe-price",
        component: () => import("../views/stripe_subsciptions/price-list.vue"),
        access: true
    },
    {
        path: base + "admin-order",
        name: "admin-order",
        component: () => import("../views/admin-order/adminorder.vue"),
        access: true
    }
  
    
];


const notificationRoutes = [
    {
        path: base + "send_notification/send-notification",
        name: "send-notification",
        component: () => import("../views/send_notification/notification.vue"),
    },
    {
        path: base + "send_notification",
        name: "notification-history",
        component: () => import("../views/send_notification/history.vue"),
    },
];

const router = new Router({
    mode: "history",
    // base,
    routes: [
        {
            path: '/',
            redirect: { name: 'dashboard' } 
        },
        ...vendorRoutes,
        {
            path: '*',  
            redirect: { name: 'dashboard' }
        }
        // ...restaurantRoutes,
        // ...resturantRoutes
    ],
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
});
router.beforeEach((to, from, next) => {
    $("body").addClass("sidebar-disable").removeClass("sidebar-enable");
    var noauth = [
        "login",
        "admin-login",
        "forgot-password",
        "vendor.login",
        "signup",
        "vendor.signup",
        "change-log",
        "driver-signup",
        "quick-signup",
        "permission-page",
        "subscriptions.details",
        'account-setup'
    ];
    let nosideMenuRoute = [
        "vendor.vendor.add.customization",
        "vendor-add-sub-customization",
    ];
    const menu = vendorRoutes.find((u) => u.name == to.name);
    // const sidemenu = urls.find(u => menu && menu.path.includes(u.link));
    const sidemenu = urls.find(
        (u) =>
            menu &&
            ((menu.path.includes(u.link) && menu.path.startsWith(u.link)) ||
                menu.link == u.link)
    );

    if (!noauth.includes(to.name)) {
        if (!Vue.prototype.$auth || !Vue.prototype.$auth.setting) {
            Vue.prototype.$auth.setUser((type) => {
                if (noauth.includes(type)) next({ name: type });
                else {
                    if (
                        Vue.prototype.$auth.user.login_type != "vendor" ||
                        menu.access ||
                        Vue.prototype.$auth.user.access.some((s) =>
                            sidemenu.permissions.some((p) => p.includes(s))
                        )
                    ) {
                        if (
                            to.name == "call-center-dashboard" &&
                            !Vue.prototype.$auth.isCallcenterActive()
                        ) {
                            error_message("Permission required");
                            if (from.name) {
                                next({ name: from.name });
                            } else {
                                next({ name: "login" });
                            }
                        } else if (
                            to.name == "web-layout-setting" &&
                            !Vue.prototype.$auth.isWebOrderingActive()
                        ) {
                            error_message("Permission required");
                            if (from.name) {
                                next({ name: from.name });
                            } else {
                                next({ name: "login" });
                            }
                        } else if (
                            to.name == "send-notification" &&
                            !Vue.prototype.$auth.isNotificationActive()
                        ) {
                            error_message("Permission required");
                            if (from.name) {
                                next({ name: from.name });
                            } else {
                                next({ name: "login" });
                            }
                        } else if (
                            to.name == "chat-list" &&
                            !Vue.prototype.$auth.isChatActive()
                        ) {
                            error_message("Permission required");
                            if (from.name) {
                                next({ name: from.name });
                            } else {
                                next({ name: "login" });
                            }
                        } else {
                            //next();
                            let host = window.location.hostname;
                            if (host.includes("pos")) {
                                let routename = "table-view";
                                next({ name: routename });
                            } else {
                                next();
                            }
                        }
                    } else {
                        error_message("Permission required");
                        if (from.name) {
                            next({ name: from.name });
                        } else {
                            next({ name: "permission-page" });
                        }
                    }
                }
            });
        } else {
            let menuAccess = menu
                ? menu.access
                : nosideMenuRoute.includes(to.name)
                ? true
                : undefined;
            if (
                Vue.prototype.$auth.user.login_type != "vendor" ||
                menuAccess ||
                (sidemenu &&
                    Vue.prototype.$auth.user.access.some((s) =>
                        sidemenu.permissions.some((p) => p.includes(s))
                    ))
            ) {
                next();
            } else {
                error_message("Permission required");
                // next({name: from.name});
                if (from.name) {
                    next({ name: from.name });
                } else {
                    next({ name: "login" });
                }
            }
        }
    } else {
        // if (from.name == 'signup' || from.name == 'quick-signup') {
        //   next({name: from.name});
        // } else {
        next();
        // }
    }
});
export default router;
